import gql from 'graphql-tag';

const GET_ORG_MEDIA = gql`
  query orgMedia($mediaId: ID) {
    media(where: { id: $mediaId }) {
      id
      name
      size
      fileType
      height
      width
      key
      url
      type
      createdAt
      org {
        id
        name
      }
      sharedWith {
        name
      }
      mediaNotes
      mediaHasNotes
    }
  }
`;

export default GET_ORG_MEDIA;
